 <template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-information</v-icon>
      <v-toolbar-title>System Information</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <div v-if="messageData.length > 0" class="pb-3">
        <span class="info-dialog-msg-header">Oops something went wrong...</span>
        <v-spacer class="mt-2"></v-spacer>
        <ul class="showErrorMsgs">
          <li v-for="(error, index) in messageData" :key="index">
            {{ error.message }}
          </li>
        </ul>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red darken-1" text @click="closeDialog">Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      showAcctInfoDialog: false
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    }
  },
  props: {
    showInfoDialog: {
      type: Boolean,
      default: true
    },
    callerPage: {
      type: String,
      default: null
    },
    messageData: {
      type: Array,
      default: null
    }
  }
}
</script>
